import React from "react";
import { useTranslate } from "utility/context/Language";
const TitleMenu = ({ title }) => {
    const { labels } = useTranslate();
    const translateTitle = labels?.sidebar?.menu[title] ? labels?.sidebar?.menu[title] : title;
    return <span className="menu-item menu-title">{translateTitle}</span>
}
export default TitleMenu